import React from 'react';

import { Box, Typography } from '@mui/material';

import { RiInformationLine } from 'react-icons/ri';
import ExternalLink from 'components/ExternalLink';
import { Trans } from 'services/localization';

const PlansLearnMoreLink = () => {
	return (
		<Box mt={7} mb={3} display="flex" justifyContent="center" alignItems="center">
			<RiInformationLine size={22} />
			<Typography variant="body2" color="secondary" marginLeft={1}>
				<Trans
					i18nKey={'plans.learnMore'}
					components={{
						externalLink: (
							<ExternalLink href="https://rentle.io/pricing">{'plans and pricing'}</ExternalLink>
						),
					}}
					defaultValue="Learn more about <externalLink>plans and pricing</externalLink>"
				/>
			</Typography>
		</Box>
	);
};

export default PlansLearnMoreLink;
